<template>
 <main class="html-page home-page blog-page">
<main><section class="page-hero blog-hero" data-bloco="blog-hero" data-tipo="hero"><div class="container blog-hero-grid"><div class="blog-hero-copy"><p class="eyebrow" data-campo="iti_nome" v-html="html(blogHero, 'iti_nome')"></p><h1 data-campo="iti_resumo1" v-html="html(blogHero, 'iti_resumo1')"></h1><p data-campo="iti_descricao1" v-html="html(blogHero, 'iti_descricao1')"></p></div><div class="blog-hero-media"><img v-if="image(blogHero)" alt="Veterinária pesquisando informações de saúde com cão e gato" data-img="imagem" :src="image(blogHero)" @error="hideBrokenImage"></div></div></section>
<section class="section blog-listing" data-bloco="blog-lista" data-tipo="lista" :style="bg(blogLista)"><div class="container"><div class="blog-tools"><div class="blog-search"><span aria-hidden="true">⌕</span><input v-model.trim="searchQuery" type="search" placeholder="Buscar por assunto..." aria-label="Buscar no blog" data-blog-search=""></div><div class="blog-filters" aria-label="Filtrar conteúdos"><button type="button" data-blog-filter="todos"></button><button type="button" data-blog-filter="prevencao"></button><button type="button" data-blog-filter="diagnostico"></button><button type="button" data-blog-filter="cardiologia"></button><button type="button" data-blog-filter="bem-estar"></button></div></div><div class="blog-grid" data-repetidor="blog-lista">
<article class="blog-card featured" data-item="" data-blog-category="prevencao" data-blog-title="Como acompanhar a vacinação de cães e gatos" v-for="(item, index) in paginatedBlog" :key="item.itiId || index"><router-link class="blog-card-image" :to="blogRoute(item)"><img v-if="image(item)" :alt="text(item, 'iti_nome')" data-img="imagem" :src="image(item)" @error="hideBrokenImage"><span class="tag" v-html="html(item, 'iti_campo_extra2')"></span></router-link><div class="blog-card-body"><small v-html="html(item, 'iti_campo_extra1')"></small><router-link :to="blogRoute(item)"><h2 data-campo="iti_nome" v-html="html(item, 'iti_nome')"></h2></router-link><p data-campo="iti_resumo1" v-html="html(item, 'iti_resumo1')"></p><router-link :to="blogRoute(item)" class="text-link" data-link="iti_linkbtn1">Ler conteúdo →</router-link></div></article>
</div><p v-if="!filteredBlog.length" class="blog-empty">Nenhum conteúdo encontrado.</p><nav v-if="totalPages > 1" class="blog-pagination" aria-label="Paginação do blog"><button type="button" :disabled="currentPage === 1" aria-label="Página anterior" @click="setPage(currentPage - 1)">‹</button><button v-for="page in totalPages" :key="page" type="button" :class="{ active: currentPage === page }" :aria-current="currentPage === page ? 'page' : undefined" @click="setPage(page)">{{ page }}</button><button type="button" :disabled="currentPage === totalPages" aria-label="Próxima página" @click="setPage(currentPage + 1)">›</button></nav></div></section></main>
<a class="whatsapp" href="https://wa.me/5551991544590" aria-label="Falar pelo WhatsApp"><span></span></a>
</main> 
</template>

<script>
import {
  contentValue,
  firstImage,
  gridItems,
  loadScreens,
  normalizeInternalLink,
  applyPageMeta,
  plainText,
} from '@/services/contentApi';

export default {
  name: 'BlogView',
  data() {
    return {
      blogHero: {},
      blogLista: [],
      searchQuery: '',
      currentPage: 1,
      itemsPerPage: 24,
      heroSlide: 0,
      carouselSlide: 0,
      carouselTimer: null,
    };
  },
  computed: {
    filteredBlog() {
      const query = plainText(this.searchQuery).toLocaleLowerCase('pt-BR');
      if (!query) return this.blogLista;
      return this.blogLista.filter((item) => {
        const searchable = [
          'iti_nome',
          'iti_resumo1',
          'iti_descricao1',
          'iti_campo_extra1',
          'iti_campo_extra2',
        ].map((field) => plainText(contentValue(item, field))).join(' ').toLocaleLowerCase('pt-BR');
        return searchable.includes(query);
      });
    },
    totalPages() {
      return Math.ceil(this.filteredBlog.length / this.itemsPerPage);
    },
    paginatedBlog() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredBlog.slice(start, start + this.itemsPerPage);
    },
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
    },
  },
  created() {
    this.loadContent();
  },
  mounted() {
    this.carouselTimer = window.setInterval(() => {
      this.nextHeroSlide();
      this.nextCarouselSlide();
    }, 5500);
  },
  beforeUnmount() {
    if (this.carouselTimer) window.clearInterval(this.carouselTimer);
  },
  methods: {
    blogRoute(item) {
      const id = item?.itiId ?? item?.iti_id ?? '';
      const slug = plainText(contentValue(item, 'iti_nome'))
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
      return { name: 'BlogDetalhe', params: { id: String(id), slug } };
    },
    setPage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.$nextTick(() => this.$el.querySelector('.blog-listing')?.scrollIntoView({ behavior: 'smooth' }));
    },
    text(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    html(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    image(source, fallback = '') {
      return firstImage(source) || fallback;
    },
    hideBrokenImage(event) { event.currentTarget.hidden = true; },
    bg(source) {
      const url = firstImage(source);
      return url ? { backgroundImage: 'url("' + url + '")' } : {};
    },
    grids(source) {
      return gridItems(source);
    },
    link(source, field, fallback = '') {
      return normalizeInternalLink(contentValue(source, field, fallback), fallback);
    },
    applyMeta(source) {
      applyPageMeta({
        title: contentValue(source, 'iti_resumo1') || contentValue(source, 'iti_nome'),
        description: contentValue(source, 'iti_descricao1') || contentValue(source, 'iti_resumo1'),
        image: firstImage(source),
      });
    },
    nextHeroSlide() {
      const total = this.homeHero?.length || this.$el.querySelectorAll('[data-vue-carousel="hero"] > [data-slide-index]').length || 1;
      this.heroSlide = (this.heroSlide + 1) % total;
    },
    goHeroSlide(index) {
      this.heroSlide = index;
    },
    nextCarouselSlide() {
      const total = this.$el.querySelectorAll('[data-vue-carousel="content"] > [data-slide-index]').length || 1;
      this.carouselSlide = (this.carouselSlide + 1) % total;
    },
    goCarouselSlide(index) {
      this.carouselSlide = index;
    },
    async loadContent() {
      const data = await loadScreens([
        {
          ctiId: 25,
          key: "blogHero",
          multi: false,
        },
        {
          ctiId: 26,
          key: "blogLista",
          multi: true,
        },
      ]);

      Object.assign(this, data);
      this.applyMeta(this.blogHero);
    },
  },
};
</script>

<style scoped>
.blog-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.blog-card.featured {
  grid-column: auto;
  display: block;
}
.blog-card.featured .blog-card-image img {
  width: 100%;
  height: 260px;
  min-height: 0;
}
.blog-card.featured .blog-card-body {
  padding: 26px;
}
.blog-card.featured .blog-card-body h2 {
  font-size: 1.35rem;
}
.blog-pagination {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 42px;
}
.blog-pagination button {
  display: grid;
  place-items: center;
  min-width: 42px;
  height: 42px;
  padding: 0 12px;
  border: 1px solid #e2d5e5;
  border-radius: 999px;
  background: #fff;
  color: #65466e;
  font: inherit;
  font-weight: 900;
  cursor: pointer;
}
.blog-pagination button.active {
  border-color: #825195;
  background: #825195;
  color: #fff;
}
.blog-pagination button:disabled {
  cursor: default;
  opacity: .4;
}
@media (max-width: 700px) {
  .blog-grid {
    grid-template-columns: 1fr;
  }
}
</style>
